import { createMemoStyles } from '@wds/styles';
var useStyles = createMemoStyles(function (_ref) {
  var spacing = _ref.spacing;
  return {
    title: {
      padding: [0, spacing[4], 0, spacing[3]]
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map